// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kore-chat-window .listTmplContent .listTmplContentBox {
  float: left;
  color: #333;
  border-radius: 12px;
  padding: 0;
  font-size: 14px;
  -webkit-animation: message-left ease-in-out 2s forwards;
  -moz-animation: message-left ease-in-out 2s forwards;
  animation: message-left ease-in-out 2s forwards;
  margin: 0;
  border: 1px solid var(--sdk-chat-widow-primary-bg-color);
  max-width: 95%;
  line-height: 1.5;
}

.kore-chat-window .listTmplContent .listLeftContent {
  display: table-cell;
  vertical-align: top;
}

.kore-chat-window .listTmplContent .listRightContent {
  width: 65px;
  height: 60px;
  cursor: pointer;
}

.kore-chat-window .listRightContent img {
  height: 57px;
  width: 57px;
  border-radius: 50%;
}

.kore-chat-window .listTmplContent .listTmplContentChild {
  border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);
  padding: 10px;
  margin: 0;
  width: 100%;
  display: table;
}

.kore-chat-window .listTmplContent .listItemSubtitle {
  font-size: 12px;
  color: var(--sdk-chat-widow-secondary-font-color);
}

.kore-chat-window .listTmplContent .listItemPath {
  font-size: 12px;
  color: #0079FF;
  cursor: pointer;
}

.kore-chat-window .listTmplContent .buyBtn {
  border: 0;
  color: var(--sdk-chat-window-btn-default-bg);
  cursor: pointer;
  float: right;
  font-weight: bold;
  letter-spacing: -0.3px;
  font-size: 12px;
  text-align: right;
}

.kore-chat-window .listTmplContentBox li:first-child {
  margin-top: 0 !important;
  border-top: 0;
}

.kore-chat-window .listTmplContent .listTmplContentHeading {
  padding: 10px;
  background: #f4f4f4;
  margin-bottom: 0;
  border-radius: 12px 12px 0 0;
  font-size: 15px;
}

.kore-chat-window .listTmplContent .listItemTitle,
.kore-chat-window .listItemSubtitle,
.kore-chat-window .listItemPath {
  padding: 3px 0;
  font-size: 13px;
}

.kore-chat-window .listItemTitle {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.54;
  letter-spacing: -0.1px;
  color: var(--sdk-chat-window-bot-bubble-font-clr);
}

.kore-chat-window .listTmplContent .viewMoreList {
  text-align: center;
  border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);
  padding: 10px;
  margin: 0;
}

.kore-chat-window .listTmplContent .viewMore {
  border: 0;
  background: none;
  color: #0079FF !important;
  font-size: 15px;
  cursor: pointer;
}

[dir=rtl].kore-chat-window .listTmplContent .listTmplContentBox {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/plugins/v2Plugin/templates/listTemplate/listTemplate.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,uDAAA;EACA,oDAAA;EACA,+CAAA;EACA,SAAA;EACA,wDAAA;EACA,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AACJ;;AAEA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AACJ;;AAEA;EACI,4DAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,iDAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;EACA,eAAA;AACJ;;AAEA;EAEI,SAAA;EACA,4CAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,wBAAA;EACA,aAAA;AAAJ;;AAGA;EACI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,4BAAA;EACA,eAAA;AAAJ;;AAGA;;;EAGI,cAAA;EACA,eAAA;AAAJ;;AAGA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,iDAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,4DAAA;EACA,aAAA;EACA,SAAA;AAAJ;;AAGA;EACI,SAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AAAJ;;AAEA;EACI,YAAA;AACJ","sourcesContent":[".kore-chat-window .listTmplContent .listTmplContentBox {\n    float: left;\n    color: #333;\n    border-radius: 12px;\n    padding: 0;\n    font-size: 14px;\n    -webkit-animation: message-left ease-in-out 2s forwards;\n    -moz-animation: message-left ease-in-out 2s forwards;\n    animation: message-left ease-in-out 2s forwards;\n    margin: 0;\n    border: 1px solid var(--sdk-chat-widow-primary-bg-color);\n    max-width: 95%;\n    line-height: 1.5;\n}\n\n.kore-chat-window .listTmplContent .listLeftContent {\n    display: table-cell;\n    vertical-align: top;\n}\n\n.kore-chat-window .listTmplContent .listRightContent {\n    width: 65px;\n    height: 60px;\n    cursor: pointer;\n}\n\n.kore-chat-window .listRightContent img {\n    height: 57px;\n    width: 57px;\n    border-radius: 50%;\n}\n\n.kore-chat-window .listTmplContent .listTmplContentChild {\n    border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);\n    padding: 10px;\n    margin: 0;\n    width: 100%;\n    display: table;\n}\n\n.kore-chat-window .listTmplContent .listItemSubtitle {\n    font-size: 12px;\n    color: var(--sdk-chat-widow-secondary-font-color);\n}\n\n.kore-chat-window .listTmplContent .listItemPath {\n    font-size: 12px;\n    color: #0079FF;\n    cursor: pointer;\n}\n\n.kore-chat-window .listTmplContent .buyBtn {\n    // background: var(--sdk-chat-widow-default-white);\n    border: 0;\n    color: var(--sdk-chat-window-btn-default-bg);\n    cursor: pointer;\n    float: right;\n    font-weight: bold;\n    letter-spacing: -0.3px;\n    font-size: 12px;\n    text-align: right;\n}\n\n.kore-chat-window .listTmplContentBox li:first-child {\n    margin-top: 0!important;\n    border-top: 0;\n}\n\n.kore-chat-window .listTmplContent .listTmplContentHeading {\n    padding: 10px;\n    background: #f4f4f4;\n    margin-bottom: 0;\n    border-radius: 12px 12px 0 0;\n    font-size: 15px;\n}\n\n.kore-chat-window .listTmplContent .listItemTitle,\n.kore-chat-window .listItemSubtitle,\n.kore-chat-window .listItemPath {\n    padding: 3px 0;\n    font-size: 13px;\n}\n\n.kore-chat-window .listItemTitle {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.54;\n    letter-spacing: -0.1px;\n    color: var(--sdk-chat-window-bot-bubble-font-clr);\n}\n\n.kore-chat-window .listTmplContent .viewMoreList {\n    text-align: center;\n    border-top: 1px solid var(--sdk-chat-widow-primary-bg-color);\n    padding: 10px;\n    margin: 0;\n}\n\n.kore-chat-window .listTmplContent .viewMore {\n    border: 0;\n    background: none;\n    color: #0079FF!important;\n    font-size: 15px;\n    cursor: pointer;\n}\n[dir=\"rtl\"].kore-chat-window .listTmplContent .listTmplContentBox{\n    float: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
